import styled from 'styled-components';

export const RegexMatchRuleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;
